const height = {
	headerStaticHeight: 115,
	headerFixedHeight:  102,
}

export { height }
